module.exports = __webpack_public_path__ + "static/speak-e23ca8c55d13dfa8ee34a68c3f318f73.jpg";